// frontend/src/components/Mobile/MobileHome.jsx
// First mobile page: one big icon per mobile screen, built from mobileMenu.js.
// Only the screens the user has read permission for are enabled; screens
// without permission are hidden (set SHOW_LOCKED = true to show them greyed out).

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { usePermissions } from '../../context/PermissionsContext';
import { FiLock } from 'react-icons/fi';
import MobileLayout from './MobileLayout';
import MobileNoAccess from './MobileNoAccess';
import { MOBILE_MENU } from './mobileMenu';
import './Mobile.css';

const SHOW_LOCKED = false;

const MobileHome = () => {
  const { user } = useAuth();
  const { can } = usePermissions();
  const navigate = useNavigate();

  const entries = MOBILE_MENU
    .map((m) => ({ ...m, allowed: can(m.key, 'read') }))
    .filter((m) => m.allowed || SHOW_LOCKED);

  if (!entries.some((m) => m.allowed)) return <MobileNoAccess />;

  // group by app area (FastReact, …) keeping menu order
  const groups = [];
  entries.forEach((m) => {
    let g = groups.find((x) => x.name === m.group);
    if (!g) { g = { name: m.group, items: [] }; groups.push(g); }
    g.items.push(m);
  });

  const name = user?.full_name || user?.username || '';

  return (
    <MobileLayout title="Quantix Works">
      {name && <div className="mb-home-hello">Olá, {name}</div>}

      {groups.map((g) => (
        <div key={g.name} className="mb-home-group">
          <div className="mb-section-label">{g.name}</div>
          <div className="mb-home-grid">
            {g.items.map(({ key, path, label, icon: Icon, allowed }) => (
              <button
                key={key}
                type="button"
                className={`mb-home-tile ${allowed ? '' : 'mb-home-tile--locked'}`}
                disabled={!allowed}
                onClick={() => navigate(path)}
              >
                <span className="mb-home-icon">
                  {allowed ? <Icon size={30} /> : <FiLock size={26} />}
                </span>
                <span className="mb-home-label">{label}</span>
              </button>
            ))}
          </div>
        </div>
      ))}
    </MobileLayout>
  );
};

export default MobileHome;